import { useEffect, useRef, useState } from 'react';

// Avisa quando existe um deploy mais novo do que o que está carregado NESTA aba, e oferece um botão
// pra recarregar. Pedido do Jason (28/09/2026): "o painel não deveria ter cache" — o problema real não
// é cache HTTP (o index.html já não é cacheado, ver public/_headers), é que um SPA, uma vez carregado,
// NUNCA recarrega sozinho — a aba continua rodando o JavaScript antigo pra sempre, mesmo com deploys
// novos, até alguém dar F5. Isso é normal de qualquer SPA (Gmail, Slack etc. fazem o mesmo tipo de
// aviso), não é bug — mas sem avisar, fica parecendo "não funcionou" quando na verdade só falta recarregar.
//
// Como funciona: o nome do arquivo do bundle tem hash (main.<hash>.js) — um deploy novo sempre gera um
// hash novo. Captura qual bundle ESTA aba carregou (lendo a própria tag <script> da página) e, de tempos
// em tempos, busca o index.html fresco (sem cache) pra comparar. Se o hash mudou, é porque saiu um
// deploy novo depois que esta aba foi aberta.
const INTERVALO_MS = 5 * 60 * 1000; // 5 minutos

function bundleAtual() {
  const script = Array.from(document.scripts).find((s) => /\/static\/js\/main\.[^./]+\.js$/.test(s.src));
  return script ? script.src.split('/').pop() : null;
}

async function bundlePublicado() {
  try {
    const r = await fetch('/', { cache: 'no-store' });
    const html = await r.text();
    const m = html.match(/\/static\/js\/main\.[^"./]+\.js/);
    return m ? m[0].split('/').pop() : null;
  } catch {
    return null; // offline ou falha de rede — não é motivo pra avisar de nada
  }
}

export default function AtualizacaoDisponivel() {
  const [disponivel, setDisponivel] = useState(false);
  const [dispensado, setDispensado] = useState(false);
  const bundleInicial = useRef(bundleAtual());

  useEffect(() => {
    if (!bundleInicial.current) return undefined; // ambiente sem build hasheado (ex.: npm start) — não checa

    async function conferir() {
      const novo = await bundlePublicado();
      if (novo && novo !== bundleInicial.current) setDisponivel(true);
    }
    conferir();
    const intervalo = setInterval(conferir, INTERVALO_MS);
    // Conferir também quando a pessoa volta pra aba (deixou aberta e foi fazer outra coisa).
    const aoVoltarFoco = () => { if (document.visibilityState === 'visible') conferir(); };
    document.addEventListener('visibilitychange', aoVoltarFoco);
    return () => {
      clearInterval(intervalo);
      document.removeEventListener('visibilitychange', aoVoltarFoco);
    };
  }, []);

  // Não é obrigatório atualizar agora — quem dispensar não vê de novo nesta aba (não fica insistindo).
  function dispensar() {
    setDispensado(true);
  }

  if (!disponivel || dispensado) return null;

  return (
    <div
      className="d-flex justify-content-between align-items-center gap-2 px-3 py-2 text-white"
      style={{ background: 'var(--cor-primaria)', fontSize: 14 }}
    >
      <span>Uma nova versão do painel está disponível.</span>
      <div className="d-flex align-items-center gap-2">
        <button type="button" className="btn btn-sm btn-warning fw-semibold" onClick={() => window.location.reload()}>
          Atualizar agora
        </button>
        <button type="button" className="btn-close btn-close-white" aria-label="Dispensar" onClick={dispensar} />
      </div>
    </div>
  );
}
